import { fetchPage, signatureOf } from './api';

const extractError = err => (err && err.response ? err.response.status : 'NETWORK');

/** Fetch page 1 (resets the list). Used on mount and on every search/sort/channel change. */
export function fetchVideos(search, sort, channel) {
  const signature = signatureOf(search, sort, channel);
  return dispatch => {
    dispatch({ type: 'FETCH_VIDEOS', payload: { signature } });
    return fetchPage(search, sort, 1, channel).then(
      ({ list, hasMore }) => dispatch({ type: 'FETCH_VIDEOS_FULFILLED', payload: { list, hasMore, page: 1, signature } }),
      err => dispatch({ type: 'FETCH_VIDEOS_REJECTED', payload: { status: extractError(err), signature } })
    );
  };
}

/** Fetch the next page and append it to the current list ("Charger plus"). */
export function loadMoreVideos(search, sort, nextPage, channel) {
  const signature = signatureOf(search, sort, channel);
  return dispatch => {
    dispatch({ type: 'FETCH_VIDEOS_MORE', payload: { signature } });
    return fetchPage(search, sort, nextPage, channel).then(
      ({ list, hasMore }) =>
        dispatch({ type: 'FETCH_VIDEOS_MORE_FULFILLED', payload: { list, hasMore, page: nextPage, signature } }),
      err => dispatch({ type: 'FETCH_VIDEOS_MORE_REJECTED', payload: { status: extractError(err), signature } })
    );
  };
}
